import { useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
// import React from 'react';
import Nav from "./components/navBar/Nav";
import EnFooter from "./components/footer/Footer";

const Layout = () => {
  const [outletRendered, setOutletRendered] = useState(false);

  useEffect(() => {
    setOutletRendered(true);
  }, []);

  useEffect(() => {
    const addGoogleTranslateScript = () => {
      if (window.google && window.google.translate) return;

      const script = document.createElement("script");
      script.src =
        "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
      script.async = true;
      document.body.appendChild(script);
    };

    window.googleTranslateElementInit = () => {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
        },
        "google_translate_element"
      );
    };

    addGoogleTranslateScript();
  }, []);

  return (
    <main>
      <Nav />
      <Outlet />
      {outletRendered && <EnFooter />}
    </main>
  );
};

export default Layout;
